module.exports = __webpack_public_path__ + "static/0086-56576a56c64c6253d7af1267b826e096.png";